import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig).catch((err) => {
  console.error(err);
  const root = document.getElementById('app-bootstrap-error');
  if (root) root.removeAttribute('hidden');
});
